import { Alert, Slide, SlideProps, Snackbar } from '@mui/material';
import { IS_TEST_MODE } from 'constants/global';
import React from 'react';
import { IProps } from 'types/common';
import { IToast, SetToastFunc } from 'types/toast';
import ToastContext from './ToastContext';

type TransitionProps = Omit<SlideProps, 'up'>;

const TransitionRight = (props: TransitionProps) => (
	<Slide {...props} direction="right" />
);

const ToastProvider: React.FC<IProps> = ({ children }) => {
	const [open, setOpen] = React.useState<boolean>(false);
	const [toast, setToast] = React.useState<IToast | null>(null);

	const handleToastChanged = React.useCallback<SetToastFunc>(
		(t: IToast) => {
			if (t?.error && !IS_TEST_MODE) {
				console.error(t?.error); // eslint-disable-line
			}
			setToast(t);
			setOpen(true);
		},
		[setToast, setOpen]
	);

	return (
		<ToastContext.Provider value={handleToastChanged}>
			<Snackbar
				open={open}
				autoHideDuration={5000}
				onClose={(_event: React.SyntheticEvent | Event, reason?: string) => {
					if (reason === 'clickaway') {
						return;
					}
					setOpen(false);
				}}
				TransitionComponent={TransitionRight}
				TransitionProps={{
					onAnimationEnd: () => setToast(null)
				}}
				transitionDuration={300}
				sx={{
					position: 'absolute',
					mb: 8,
					whiteSpace: 'break-spaces'
				}}
			>
				<Alert data-testid={toast?.id} severity={toast?.severity}>
					{toast?.content}
				</Alert>
			</Snackbar>
			{children}
		</ToastContext.Provider>
	);
};

export default ToastProvider;
